import { useLanguage } from '../../i18n/LanguageContext';

interface SettingsHeaderProps {
  garageName: string;
  email: string;
  phone: string;
  logoUrl: string | null;
  onEditProfile: () => void;
}

export default function SettingsHeader({ garageName, email, phone, logoUrl, onEditProfile }: SettingsHeaderProps) {
  const { t } = useLanguage();

  return (
    <div className="settings-header">
      <div className="settings-header-info">
        <div className="settings-header-logo">
          {logoUrl ? (
            <img src={logoUrl} alt={garageName} />
          ) : (
            <div className="settings-header-logo-placeholder">
              {garageName?.charAt(0) || 'G'}
            </div>
          )}
        </div>
        <div className="settings-header-details">
          <h2 className="settings-header-name">{garageName}</h2>
          <div className="settings-header-contact">
            <div><span className="settings-label">{t('settings.email')}</span> <span>{email}</span></div>
            <div><span className="settings-label">{t('settings.phone')}</span> <span>{phone}</span></div>
          </div>
        </div>
      </div>
      <button className="settings-edit-profile-btn" onClick={onEditProfile}>
        {t('settings.editProfile')} ✏️
      </button>
    </div>
  );
}
